module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmtitle1"
  }, [_c('a', {
    attrs: {
      "id": "h4"
    }
  }, [_vm._v("HISTORICAL CONTEXT")])]), _c('a', {
    attrs: {
      "id": "h4"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The British Army in the form of General Smith-Dorrien’s II Corps arrived in the area in early October 1914 after transferring from the Aisne further south. Their task was to link up with the French Tenth Army in the La Bassée area and, together with the Allied forces further north around Messines and Ypres, advance eastwards. Initial gains made by a tired and under strength II Corps were soon pushed back by the advancing German Sixth Army to a line which, apart from some minor territorial movements, remained largely static until March 1915. After the battles of 1915 the front line altered very little until April 1918 when the German offensive marked the end of the trench stalemate before it was finally stopped short of Hazebrouck.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By 31 December 1914 the five corps of the British Army – including one Indian – had been reorganized into two army groups: the First Army under the command of "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("General Sir Douglas Haig")]), _vm._v(", comprising I and II Corps and the Indian Corps; and the Second Army, commanded by "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("General Sir Horace Smith-Dorrien")]), _vm._v(", comprising, III and IV Corps and the 27th Division. Although the units of the Indian Corps were largely made up of Indian regiments staffed in the main by British officers, the Corps contained a number of British battalions in each division. The Cavalry Corps now included the Indian Cavalry Corps and was under the command of "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Lieutenant General Sir Edmund Allenby")]), _vm._v(". In overall command of the BEF was "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Field Marshal Sir John French")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-052b89fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/17_fm03.vue
// module id = 108
// module chunks = 0